/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import { EmployeeCard, CardContainer } from '../index';
import { format } from 'date-fns';
import { useState } from 'react';
import { Typography } from '@mui/material';

export const AllEmployees = (props) => {
  const dateFormat = 'dd MMM yyyy';
  const timeFormat = 'hh:mm:ss a';
  const today = format(new Date(), dateFormat);
  const entryPerPage = 50; //[EPSv5_AllEmployees-UsedToBe18]
  const [slice, setSlice] = useState([0, entryPerPage]);
  const formatSafe = (dateValue, formatString, fallback = 'N/A') => {
    if (!dateValue) return fallback;
    const parsedDate = new Date(dateValue);
    return isNaN(parsedDate.getTime()) ? fallback : format(parsedDate, formatString);
  };

  // PAGE CHANGE HANDLER
  const handlePageChange = (e, page) => {
    let currPage = page - 1;

    page === 1
      ? setSlice([0, entryPerPage])
      : setSlice([currPage * entryPerPage, page * entryPerPage]);
  };

  return (
    <>
      <CardContainer
        length={props.data.length}
        entryPerPage={entryPerPage}
        pageCount={Math.floor(props.data.length / entryPerPage)}
        handlePageChange={handlePageChange}
        noRecord={props.noRecord}
        spacing={2}
      >
        {props.data.length !== 0 ? (
          <>
            {props.data.slice(slice[0], slice[1]).map((emp, index) => {
              const lastLoginFormatted = formatSafe(emp?.lastlogindate, dateFormat, null);
              const checkinFormatted = formatSafe(emp?.checkin, timeFormat, 'No Check-in time');
              const checkoutFormatted = formatSafe(emp?.checkout, timeFormat, 'No Check-out time');

              let timeDisplay = 'No record history';
              if (lastLoginFormatted && lastLoginFormatted !== today) {
                timeDisplay = `Last Login: ${lastLoginFormatted}`;
              } else if (emp?.active) {
                timeDisplay = `Check In: ${checkinFormatted}`;
              } else {
                timeDisplay = `Check Out: ${checkoutFormatted}`;
              }

              return (
                <EmployeeCard
                  view={props.view}
                  key={index}
                  id={emp?._id}
                  isActive={emp?.active}
                  name={`${emp?.firstname || ''} ${emp?.lastname || ''}`.trim() || 'Unknown Employee'}
                  time={timeDisplay}
                />
              );
            })}
          </>
        ) : (
          <Typography
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: '100%',
              my: 5,
            }}
          >
            No Active Employees
          </Typography>
        )}
      </CardContainer>
    </>
  );
};
